import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SubmitButton from '../submit-button/submit-button';
import InputField from '../input-field/input-field';
import AuthPanel from '../auth-panel/auth-panel';
import LoginService from '../../services/login-service';
import ErrorCode from '../../models/error-code';
import ApiError from '../../models/api-error';
import StorageService from '../../services/storage-service';
// import { Link } from 'react-router-dom';

import styles from './login.module.css';
import { validateEmail } from '../../helpers/validate-helper';

export default function Login(props) {
  const initialState = {
    email: '',
    password: '',
    continueButtonDisabled: false,
    validationError: {
      email: undefined,
      password: undefined,
      form: undefined,
    },
  };

  const _loginService = new LoginService();
  const _storageService = new StorageService();
  const navigate = useNavigate();
  const [formState, setFormState] = useState(initialState);

  const fieldHandler = (field: string) => (e) => {
    const newState = Object.assign({}, formState, {
      [field]: e.target.value,
      validationError: {},
    });

    setFormState(newState);
  };

  const formHandler = {};

  const getFormHandler = (field: string) => {
    if (!formHandler[field]) {
      formHandler[field] = fieldHandler(field);
    }

    return formHandler[field];
  };

  const getValidationError = (e: ApiError) => {
    let field = 'form';
    if (e.code === ErrorCode.EmailNotFound) {
      field = 'email';
    } else if (e.code === ErrorCode.InvalidPassword) {
      field = 'password';
    }

    return { [field]: `(${e.code}) ${e.message}` };
  };

  const validateInputsValues = (email?: string, password?: string) => {
    let emailMessage: string | undefined = undefined;
    let passwordMessage: string | undefined = undefined;

    const emailValidate = validateEmail(email);
    if (email && email.length > 0 && !emailValidate.isValid) {
      emailMessage = emailValidate.message;
    }

    // Only check if password field is empty, don't validate format for security reasons
    if (!email || !password) {
      emailMessage = !email ? 'Campo e-mail vazio.' : emailMessage;
      passwordMessage = !password ? 'Campo senha vazio.' : passwordMessage;
    }

    if (emailMessage === undefined && passwordMessage === undefined) {
      return false;
    } else {
      const error = {
        validationError: {
          email: emailMessage,
          password: passwordMessage,
        },
      };

      setFormState(Object.assign({}, formState, error));

      return true;
    }
  };

  const onLoginClick = async () => {
    const { email, password } = formState;

    if (validateInputsValues(email, password)) {
      return;
    } else {
      try {
        const authInfo = await _loginService.authenticate(email, password);
        _storageService.setAuthInfo(authInfo);
        navigate('/');
      } catch (e) {
        const result = getValidationError(e);
        setFormState(Object.assign({}, formState, { validationError: result }));
      }
    }
  };

  const emailMessage = formState.validationError.email;
  const passwordMessage = formState.validationError.password;
  const formMessage = formState.validationError.form;
  const inputContainerStyle = { width: '100%' };
  const inputStyle = { backgroundColor: 'var(--eraser)' };
  return (
    <AuthPanel>
      <form onSubmit={(evt) => evt.preventDefault()}>
        <div
          className={`${styles.loginFieldSet}`}
          style={{ marginTop: '42px' }}
        >
          <InputField
            type='text'
            inputId='email'
            label='email'
            placeholder='insira seu email'
            validationMessage={emailMessage}
            onChange={getFormHandler('email')}
            inputContainerStyle={inputContainerStyle}
            inputStyle={inputStyle}
          />
        </div>
        <div
          className={`${styles.loginFieldSet}`}
          style={{ marginTop: '24px' }}
        >
          <InputField
            type='password'
            inputId='password'
            label='senha'
            placeholder='insira sua senha'
            validationMessage={passwordMessage}
            onChange={getFormHandler('password')}
            inputContainerStyle={inputContainerStyle}
            inputStyle={inputStyle}
          />
        </div>
        {/* TODO: Remove comment when implement forgot password API */}
        {/* <div className='login-forgot-password'>
        <Link to='/esqueci-minha-senha' className='support-sb'>
          Esqueci minha senha
        </Link>
      </div> */}
        <div className='login-button'>
          <SubmitButton
            variant='primary'
            buttonStyle={{ width: '100%' }}
            value='continuar'
            disabled={formState.continueButtonDisabled}
            onClick={onLoginClick}
          />
        </div>

        {formMessage ? (
          <div style={{ marginTop: '8px' }}>
            <span className='support-sb font-curiosity'>{formMessage}</span>
          </div>
        ) : null}
      </form>
    </AuthPanel>
  );
}
